import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/productos-entregas";

const getProductosEntregas = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data.data;
};

const getDetalleProducto = async (params) => {
  const response = await axios.get(`${baseUrl}${endpoint}/detalle`, {
    params
  });

  return response.data.data;
};

const getDetalleProductoAll = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}/detalle-all`);
  return response.data.data;
};

export {
  getProductosEntregas,
  getDetalleProducto,
  getDetalleProductoAll 
};